export default {
  props: {
    mode: String,
    origin: String,
    transition: String
  }
}



// WEBPACK FOOTER //
// ./src/mixins/transitionable.js